<template>
  <footer class="bg-dark text-white text-center py-4 mt-5">
    <div class="container">
      <p class="mb-1">© 2025 56yellowrosesLLC. All Rights Reserved.</p>
      <p class="small">
        <a href="mailto:info@yellowroses.com" class="text-white text-decoration-none">info@56yellowrosesLLC.com</a>
        &nbsp;|&nbsp;
        <a href="#" class="text-white text-decoration-none">Privacy Policy</a>
      </p>
    </div>
  </footer>
</template>
